import { INTEGRATIONS_ACTIONS } from './integrations.types'

/**
 *
 * @param {import('./integrations.types').FeaturebaseSlice['status']} payload
 * @returns {import('./integrations.types').FeaturebaseStatusAction}
 */
export const setFeaturebaseStatusAction = payload => ({ type: INTEGRATIONS_ACTIONS.SET_FEATUREBASE_STATUS, payload })

/**
 *
 * @param {import('../slice.types').SliceError} payload
 * @returns {import('./integrations.types').FeaturebaseErrorsAction}
 */
export const setFeaturebaseErrorsAction = payload => ({ type: INTEGRATIONS_ACTIONS.SET_FEATUREBASE_ERRORS, payload })

/**
 *
 * @param {import('./integrations.types').FeaturebaseSlice['task']} payload
 * @returns {import('./integrations.types').FeaturebaseTaskAction}
 */
export const setFeaturebseTaskAction = payload => ({ type: INTEGRATIONS_ACTIONS.SET_FEATUREBASE_TASK, payload })

/**
 *
 * @param {import('./integrations.types').FeaturebaseSlice['changelog']} payload
 * @returns {import('./integrations.types').AuthTokenAction}
 */
export const setFeaturebaseChangelogAction = payload => ({
  type: INTEGRATIONS_ACTIONS.SET_FEATUREBASE_CHANGELOG,
  payload
})

/**
 * @param {any} payload
 * @returns {{ type: string, payload: any }}
 */
export const fetchIntegrationsAction = payload => ({ type: INTEGRATIONS_ACTIONS.FETCH_INTEGRATIONS, payload })

/**
 * @param {any} payload
 * @returns {{ type: string, payload: any }}
 */
export const fetchIntegrationAction = payload => ({ type: INTEGRATIONS_ACTIONS.FETCH_INTEGRATION, payload })

/**
 * @param {any} payload
 * @returns {{ type: string, payload: any }}
 */
export const fetchAgencyIntegrationAction = payload => ({
  type: INTEGRATIONS_ACTIONS.FETCH_AGENCY_INTEGRATION,
  payload
})

/**
 * @param {any} payload
 * @returns {{ type: string, payload: any }}
 */
export const fetchAgencyIntegrationsAction = payload => ({
  type: INTEGRATIONS_ACTIONS.FETCH_AGENCY_INTEGRATIONS,
  payload
})

/**
 * @param {any} payload
 * @returns {{ type: string, payload: any }}
 */
export const fetchAgencyIntegrationsByIntegrationIdAction = payload => ({
  type: INTEGRATIONS_ACTIONS.FETCH_AGENCY_INTEGRATIONS_BY_INTEGRATION_ID,
  payload
})

/**
 * @param {any} payload
 * @returns {{ type: string, payload: any }}
 */
export const fetchAvailablePortalsAction = payload => ({
  type: INTEGRATIONS_ACTIONS.FETCH_PORTALS_FOR_INTEGRATION,
  payload
})

/**
 * @param {any} payload
 * @returns {{ type: string, payload: any }}
 */
export const setSelectedPortalsAction = payload => ({
  type: INTEGRATIONS_ACTIONS.SET_PORTALS_FOR_INTEGRATION,
  payload
})

/**
 * @param {any} payload
 * @returns {{ type: string, payload: any }}
 */
export const fetchAssignedPortalsAction = payload => ({
  type: INTEGRATIONS_ACTIONS.FETCH_ASSIGNED_PORTALS_FOR_INTEGRATION,
  payload
})

/**
 * @param {any} payload
 * @returns {{ type: string, payload: any }}
 */
export const fetchAvailableClientsAction = payload => ({
  type: INTEGRATIONS_ACTIONS.FETCH_CLIENTS_FOR_INTEGRATION,
  payload
})

/**
 * @param {any} payload
 * @returns {{ type: string, payload: any }}
 */
export const fetchAssignedClientsAction = payload => ({
  type: INTEGRATIONS_ACTIONS.FETCH_ASSIGNED_CLIENTS_FOR_INTEGRATION,
  payload
})

/**
 * @param {any} payload
 * @returns {{ type: string, payload: any }}
 */
export const fetchPortalIntegrationsAction = payload => ({
  type: INTEGRATIONS_ACTIONS.FETCH_PORTAL_INTEGRATIONS,
  payload
})

/**
 * @param {any} payload
 * @returns {{ type: string, payload: any }}
 */
export const fetchPortalIntegrationAction = payload => ({
  type: INTEGRATIONS_ACTIONS.FETCH_PORTAL_INTEGRATION,
  payload
})

/**
 * @param {any} payload
 * @returns {{ type: string, payload: any }}
 */
export const createPortalIntegrationAction = payload => ({
  type: INTEGRATIONS_ACTIONS.CREATE_PORTAL_INTEGRATION,
  payload
})

/**
 * @param {any} payload
 * @returns {{ type: string, payload: any }}
 */
export const updatePortalIntegrationAction = payload => ({
  type: INTEGRATIONS_ACTIONS.UPDATE_PORTAL_INTEGRATION,
  payload
})

/**
 * Clears the agency integration detail state
 * @returns {{ type: string }}
 */
export const clearAgencyIntegrationDetailAction = () => ({
  type: INTEGRATIONS_ACTIONS.CLEAR_AGENCY_INTEGRATION_DETAIL
})

// /**
//  * @param {import('./integrations.types').FeaturebaseSlice['redirectUri']} payload
//  * @returns {import('./integrations.types').AuthRedirectUriAction}
//  */
// export const setRedirectUriAction = ({ url, external = false }) => ({
//   type: INTEGRATIONS_ACTIONS.SET_REDIRECT_URI,
//   payload: { url, external }
// })

// /**
//  * @returns {import('./integrations.types').AuthClearAction}
//  */
// export const clearAuthErrorsAction = () => ({ type: INTEGRATIONS_ACTIONS.CLEAR_AUTH_ERRORS })

// /**
//  * @returns {import('./integrations.types').AuthClearAction}
//  */
// export const clearAuthTaskAction = () => ({ type: INTEGRATIONS_ACTIONS.CLEAR_AUTH_TASK })

// /**
//  * @returns {import('./integrations.types').AuthClearAction}
//  */
// export const clearAuthTokenAction = () => ({ type: INTEGRATIONS_ACTIONS.CLEAR_AUTH_TOKEN })
